// English UI strings (base). Article/phase text lives in ../lib/cycle.js.
const en = {
  ui: {
    // Onboarding
    heroLine1: "Know your Phase.",
    heroLine2: "Own your Power.",
    heroSub:
      "No accounts, no logins. Just tell us about your cycle and we'll map your phases, nutrition, and movement.",
    lastPeriodLabel: "First day of last period",
    selectDate: "Select a date",
    periodLengthLabel: "Period length",
    cycleLengthLabel: "Cycle length",
    days: "days",
    weightLabel: "Body weight",
    weightPlaceholder: "e.g. 140",
    lb: "lb",
    weightHint: "Used to calculate your water & protein targets.",
    mapCycle: "Map my cycle",
    // Tabs
    tabToday: "Today",
    tabSummary: "Summary",
    tabLibrary: "Library",
    // Banner / recommendations
    dayToday: "Day {n} · Today",
    readScience: "Read the science",
    fitnessWindow: "Fitness Window",
    hormoneCare: "Hormone Care",
    water: "Water",
    protein: "Protein",
    flOz: "fl oz",
    grams: "g",
    cupsPerDay: "≈ {n} cups / day",
    focusForPhase: "Focus for this phase",
    movement: "Movement",
    carbs: "Carbs",
    fats: "Fats",
    increase: "Increase",
    maintain: "Maintain",
    reduce: "Reduce",
    fitness: "Fitness",
    hormones: "Hormones",
    today: "today",
    whyThisMatters: "Why this matters",
    // Summary
    currentCycle: "Current Cycle",
    cyclePeriodInfo: "{c}-day cycle · {p}-day period",
    dailyWater: "Daily water",
    dailyProtein: "Daily protein",
    proteinRangeNote:
      "Protein rises toward the luteal phase (~1.15 g/lb) to offset progesterone-driven protein breakdown; water stays constant at 0.5 g/lb.",
    now: "Now",
    daysCount: "{n} days",
    howToRead: "How to read this",
    increaseHint: "lean into it this phase",
    maintainHint: "keep at your baseline",
    reduceHint: "ease off this phase",
    dotsHint: "Dots = intensity level (low → high)",
    // Library
    libraryKicker: "The Library",
    libraryTitle1: "The science behind",
    libraryTitle2: "every recommendation.",
    librarySub:
      "Short, referenced reads on your hormones, nutrition, and movement — each backed by peer-reviewed studies and medical guidelines.",
    nutritionWellness: "Nutrition & Wellness",
    yourCyclePhases: "Your Cycle Phases",
    sourceCited: "source cited",
    sourcesCited: "sources cited",
    // Articles
    references: "References",
    disclaimerPhase:
      "General wellness information, not medical advice. Everyone's cycle is different — check with a healthcare professional for personal guidance.",
    disclaimerGeneral:
      "General wellness information, not medical advice. Everyone's body is different — please consult a healthcare professional for guidance specific to you.",
    hydrationLabel: "Hydration",
    nutritionLabel: "Nutrition",
    // Share
    shareBtnTitle: "Share your cycle",
    shareDesc:
      "Send this to a partner or friend — the link restores your plan on any device.",
    copyLink: "Copy link",
    copied: "Copied!",
    shareVia: "Share via…",
    image: "Image",
    pdf: "PDF",
    linkCopied: "Link copied to clipboard",
    copyFail: "Couldn't copy — long-press the link to copy manually",
    imageDownloaded: "Image downloaded",
    pdfDownloaded: "PDF downloaded",
    exportFail: "Export failed. Please try again.",
    shareText: "Here's my current cycle, nutrition & movement plan:",
    // Export sheet
    exportHeadline: "Your Cycle at a Glance",
    waterPerDay: "Water / day",
    proteinPerDay: "Protein / day",
    fullCycleOverview: "Full Cycle Overview",
    exportFooter:
      "Water = 0.5 g/lb · Protein {min}–{max} g (rises toward luteal phase). Arrows show increase / maintain / reduce vs. baseline.",
    generatedWith: "Generated with Cycle IQ",
    // Misc
    language: "Language",
    articleAbout: "About: {label}",
    weekdays: ["S", "M", "T", "W", "T", "F", "S"],
  },
};

export default en;
